import { createContext, useContext, useEffect, useState } from "react";
import { adminMe, getToken, setToken, clearToken } from "@/lib/api";

const AdminAuthContext = createContext(null);

export function AdminAuthProvider({ children }) {
  const [admin, setAdmin] = useState(null); // null = checking, false = out, object = in
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    if (!getToken()) {
      setAdmin(false);
      setChecked(true);
      return;
    }
    adminMe()
      .then((d) => setAdmin(d))
      .catch(() => {
        clearToken();
        setAdmin(false);
      })
      .finally(() => setChecked(true));
  }, []);

  const login = (token, username) => {
    setToken(token);
    setAdmin({ username });
  };
  const logout = () => {
    clearToken();
    setAdmin(false);
  };

  return (
    <AdminAuthContext.Provider value={{ admin, checked, login, logout }}>
      {children}
    </AdminAuthContext.Provider>
  );
}

export const useAdminAuth = () => useContext(AdminAuthContext);
